<template>
  <div class="renwu">
    <!-- 答卷列表 -->
    <div class="top">
      <Select class="select" v-model="naireId" placeholder="请选择问卷" @on-change="selectStatementRecordList(1)" @on-clear="selectStatementRecordList(1)" clearable>
        <Option v-for="(item, index) in juanList" :value="item.naireId + ''" :key="index">{{ item.naireNameText }}</Option>
      </Select>
      <Input v-model="patientNameLike" @on-clear="selectStatementRecordList(1)" @on-enter="selectStatementRecordList(1)" placeholder="请输入姓名进行搜索" clearable class="journal-input">
      <Icon type="ios-search" slot="prefix" />
      </Input>
      <Input v-model="idCardLike" @on-clear="selectStatementRecordList(1)" @on-enter="selectStatementRecordList(1)" placeholder="请输入身份证号进行搜索" clearable class="journal-input">
      <Icon type="ios-search" slot="prefix" />
      </Input>
      <Input v-model="phoneLike" @on-clear="selectStatementRecordList(1)" @on-enter="selectStatementRecordList(1)" placeholder="请输入手机号进行搜索" clearable class="journal-input">
      <Icon type="ios-search" slot="prefix" />
      </Input>
      <Date-picker @on-change="datePicker" :options="options" class="data" type="daterange" placeholder="选择答卷日期"></Date-picker>
      <Button class="btn fourSize" type="success" ghost @click="daochu">导出</Button>
    </div>
    <div class="table-cont">
      <Table @on-selection-change="selectChange" stripe :columns="columns" :data="data"></Table>
    </div>
    <div class="page-div">
      <div class="page-div-left">
        已选 <span>{{ selectNum }}</span> 条
      </div>
      <Page @on-page-size-change="changepeoplepage" @on-change="changePeoplecurrent" :total="obj.count" show-elevator show-total :current="current" :page-size="pageSize" show-sizer class="page-div-page" />
    </div>

    <!-- 查看弹框 -->
    <Modal class="ivumodal" footer-hide width="700" v-model="modify" title="查看详情">
      <div class="modal-cont">
        <Table stripe :columns="columns2" :data="data2"></Table>

        <div class="secondBumen-bottom">
          <Button class="btn" type="success" ghost @click="clear()">取消</Button>
          <Button class="btn sure" type="success" ghost @click="clear()">确定</Button>
        </div>
      </div>
    </Modal>

    <Modal class="ivumodal" width="500" footer-hide v-model="errors" title="确认操作">
      <div class="ivumodal-cont">
        请选择需要操作的数据。
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="bi">取消</Button>
        <Button class="btn sure" type="success" ghost @click="bi">确定</Button>
      </div>
    </Modal>

    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success">操作成功</Alert>
    <Alert class="alertTitle" v-show="alertTitleIshow2" type="error" show-icon>{{ alertTitle }}</Alert>

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
  </div>
</template>
<script>
import {
  accord,
  updateAccord,
  deleteAccord,
  backNaire,
  getAnswerListOutline
} from "../servers/api";
export default {
  name: "daJuan",
  data () {
    return {
      isiconfontshow: false,
      alertTitleIshow: false,
      alertTitleIshow2: false,
      alertTitle: "",
      selectNum: 0,
      selectList: [],
      juanList: [],
      naireId: "",
      idCardLike: "",
      phoneLike: "",
      patientNameLike: "",
      errors: false,
      xiugai: {
        invisible: "0"
      },
      modify: false,
      xiugaidata: {
        showOrder: [{
          required: true,
          message: "请输入排序",
          trigger: "blur",
          Number
        }],
        accordName: [{
          required: true,
          message: "请输入依据简称",
          trigger: "blur"
        }],
        accordDetail: [{
          required: true,
          message: "请输入依据详情",
          trigger: "blur"
        }],
        invisible: [{
          required: true,
          message: "请选择状态",
          trigger: "change",
          Number
        }]
      },
      data: [],
      data2: [],
      options: {
        shortcuts: [{
          text: "最近一周",
          value () {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          }
        }, {
          text: "最近一个月",
          value () {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          }
        }, {
          text: "最近三个月",
          value () {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          }
        }]
      },
      columns: [{
        type: "selection",
        width: 50,
        align: "center"
      }, {
        title: "姓名",
        align: "center",
        minWidth: 150,
        key: "patientName",
        ellipsis: true,
        sortable: true
      }, {
        title: "性别",
        width: 150,
        align: "center",
        key: "sex",
        ellipsis: true,
        sortable: true,
        render: (h, params) => {
          let a = "";
          if (params.row.sex == 1) {
            a = "男";
          } else if (params.row.sex == 2) {
            a = "女";
          } else {
            a = "全部";
          }
          return h("div", {}, a);
        }
      }, {
        title: "身份证号",
        align: "center",
        minWidth: 150,
        key: "idCard",
        ellipsis: true,
        sortable: true
      }, {
        title: "手机号",
        align: "center",
        minWidth: 150,
        key: "phone",
        ellipsis: true,
        sortable: true
      }, {
        title: "答卷时间",
        width: 200,
        align: "center",
        key: "answerTime",
        ellipsis: true,
        sortable: true
      }, {
        title: "操作",
        key: "awssd",
        align: "center",
        width: 150,
        fixed: "right",
        render: (h, params) => {
          return h("div", [
            h(
              "div", {
              style: {
                width: "50px",
                height: "27px",
                "line-height": "27px",
                "text-align": "center",
                "font-size": "13px",
                background: "#fff",
                border: "1px solid #53CAC3",
                "border-radius": "5px",
                "margin-left": "2px",
                cursor: "pointer",
                display: "inline-block",
                color: "#7F7F7F"
              },
              on: {
                click: () => {
                  this.chengeTable(params.row);
                }
              }
            },
              "查看"
            ),
            h(
              "div", {
              style: {
                width: "50px",
                height: "27px",
                "line-height": "27px",
                "text-align": "center",
                "font-size": "13px",
                background: "#fff",
                border: "1px solid #53CAC3",
                "border-radius": "5px",
                "margin-left": "2px",
                cursor: "pointer",
                display: "inline-block",
                color: "#7F7F7F"
              },
              on: {
                click: () => {
                  this.goExcel(params.row);
                }
              }
            },
              "导出"
            )
          ]);
        }
      }],
      columns2: [{
        title: "问题",
        align: "center",
        width: 250,
        key: "questionNameText",
        ellipsis: true,
        sortable: true
      }, {
        title: "答案",
        align: "center",
        minWidth: 150,
        key: "optionsList",
        ellipsis: true,
        sortable: true,
        render: (h, params) => {
          let name = "";
          if (params.row.optionsList) {
            if (params.row.optionsList.length == 1) {
              name = params.row.optionsList[0].optionsNameText;
            } else if (params.row.optionsList.length > 1) {
              for (let i = 0; i < params.row.optionsList.length; i++) {
                name += i + "、" + params.row.optionsList[i].optionsNameText;
              }
            }
          }
          return h("div", [
            h(
              "span", {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              },
              domProps: {
                title: name
              }
            },
              name
            )
          ]);
        }
      }],
      names: "",
      current: 1,
      pageSize: 20,
      obj: {},
      orderField: "",
      isAsc: "",
      errors: false,
      topList: [],
      invisible: "",
      answerTimeLeft: "",
      answerTimeRight: ""
    };
  },
  created () {
    this.backNaire();
  },
  methods: {
    selectChange (item) {
      //列表选择
      this.selectList = item;
      this.selectNum = this.selectList.length;
    },
    daochu () {
      //点击导出
      if (this.selectNum < 1) {
        this.errors = true;
      } else {
        let baseUrl = sessionStorage.getItem("baseUrlWTS");
        let token = JSON.parse(sessionStorage.getItem("login")).token || "";
        let list = [];
        for (let i = 0; i < this.selectList.length; i++) {
          list.push(this.selectList[i].answerId);
        }
        window.location.href =
          baseUrl +
          "/naire2/backAnswer/exportAnswerExcel?answerIds=" +
          list.join(",") +
          "" +
          "&token=" +
          token;
      }
    },
    goExcel (item) {
      //表格点击导出的id
      let baseUrl = sessionStorage.getItem("baseUrlWTS");
      let token = JSON.parse(sessionStorage.getItem("login")).token || "";
      window.location.href =
        baseUrl +
        "/naire2/backAnswer/exportAnswerExcel?answerIds=" +
        item.answerId +
        "" +
        "&token=" +
        token;
    },
    datePicker (data) {
      //时间搜索
      this.answerTimeLeft = data[0];
      this.answerTimeRight = data[1];
      this.selectStatementRecordList(1);
    },
    bi () {
      this.errors = false;
    },
    clear (index, name) {
      //确定新增修改的确定
      this.modify = false;
    },
    updateAccord () {
      //修改接口
      updateAccord(this.xiugai).then(res => {
        if (res.data.code == 10000) {
          this.modify = false;
          this.isiconfontshow = false;
          this.alertTitleIshow = true;
          setTimeout(() => {
            this.alertTitleIshow = false;
          }, 2000);
          this.selectStatementRecordList();
        } else {
          this.isiconfontshow = false;
          this.alertTitle = res.data.msg;
          this.alertTitleIshow2 = true;
          setTimeout(() => {
            this.alertTitleIshow2 = false;
          }, 2000);
          this.obj = {};
          this.data = [];
        }
      });
    },
    selectStatementRecordList (index) {
      //获取答卷列表
      this.isiconfontshow = true;
      if (index) {
        this.current = 1;
      }
      let params = {
        naireId: this.naireId,
        idCardLike: this.idCardLike,
        phoneLike: this.phoneLike,
        patientNameLike: this.patientNameLike,
        answerTimeRight: this.answerTimeRight,
        answerTimeLeft: this.answerTimeLeft,
        page: this.current,
        limit: this.pageSize,
        orderField: this.orderField,
        isAsc: this.isAsc
      };
      getAnswerListOutline(params).then(res => {
        if (res.data.code == 10000) {
          this.isiconfontshow = false;
          this.obj = res.data.data || {};
          this.data = res.data.data.data || [];
          this.selectList = [];
          this.selectNum = this.selectList.length;
        } else {
          this.isiconfontshow = false;
          this.alertTitle = res.data.msg;
          this.alertTitleIshow2 = true;
          setTimeout(() => {
            this.alertTitleIshow2 = false;
          }, 2000);
          this.obj = {};
          this.data = [];
        }
      });
    },
    listAnswer (name, answerId) {
      //获取答卷列表
      this.isiconfontshow = true;
      let params = {
        answerId: answerId,
        patientNameLike: name
      };
      getAnswerListOutline(params).then(res => {
        if (res.data.code == 10000) {
          console.log(res.data.data.data)
          this.isiconfontshow = false;
          this.data2 = res.data.data.data[0].answerDetail || [];
          this.modify = true;
        } else {
          this.isiconfontshow = false;
          this.alertTitle = res.data.msg;
          this.alertTitleIshow2 = true;
          setTimeout(() => {
            this.alertTitleIshow2 = false;
          }, 2000);
          this.data2 = [];
        }
      });
    },
    chengeTable (item) {
      //查看
      this.listAnswer(item.patientName, item.answerId);
    },
    backNaire () {
      //获取问卷接口select筛选条件
      backNaire({}).then(res => {
        if (res.data.code == 10000) {
          this.juanList = res.data.data.naireList || [];
          // this.naireId = this.juanList[0].naireId + '' || '';
          this.selectStatementRecordList(1);
        } else {
          this.juanList = [];
        }
      });
    },
    changepeoplepage (num) {
      //换每页请求多少条
      this.pageSize = num;
      this.selectStatementRecordList(1);
    },
    changePeoplecurrent (num) {
      //换页
      this.current = num;
      this.selectStatementRecordList();
    }
  }
};
</script>
<style lang="scss" scoped="" type="text/css">
@import "../css/conmmon.scss";
@import "../font/iconfont.css";
.bumenModal-item {
  margin-top: 20px;
  vertical-align: middle;
}

.select {
  width: 200px;
  // margin-right: 15px;
}

.modal-cont {
  width: 100%;
  max-height: 600px;
  overflow: hidden;
  overflow-y: visible;
  padding-bottom: 20px;
  padding-right: 20px;
}

.modal-img-cont {
  width: 100%;
  position: relative;
  border: 1px solid #53cac3;
  height: 120px;
  border-radius: 5px;
  margin-top: 10px;
}

.position {
  position: absolute;
  top: 5px;
  font-size: 25px;
  color: #53cac3;
  right: 5px;
  cursor: pointer;
}

.modal-img-cont-title {
  display: inline-block;
  height: 100%;
  width: 150px;
  line-height: 90px;
  vertical-align: top;
}

.modal-img-cont-img {
  display: inline-block;
  width: 150px;
  height: 105px;
  margin: 5px 15px;
}

.modal-num {
  width: 100%;
  text-align: right;
  color: #53cac3;
  line-height: 10px;
}

.modal-span {
  width: 178px;
  display: inline-block;
  line-height: 17px;
  vertical-align: middle;
}

.i-icon {
  font-size: 25px;
  font-weight: 700;
  line-height: 30px;
  vertical-align: middle;
  color: #53cac3;
  margin-left: 3px;
  cursor: pointer;
  display: inline-block;
}

.page-div {
  width: 100%;
  margin-top: 15px;
  background: #fff;
  // width: calc(100% - 270px);
  height: 60px;
  padding-top: 15px;
}

.renwu {
  font-size: 13px;
  padding: 15px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  overflow-y: visible;
  .btn {
    float: right;
  }
  .top {
    width: calc(100% - 250px);
    height: 60px;
    line-height: 35px;
    position: fixed;
    top: 111px;
    z-index: 99;
    background: #fff;
    padding-top: 17px;
    left: 220px;
    padding-left: 15px;
    padding-bottom: 15px;
  }
  .journal-input {
    width: 180px;
    vertical-align: top;
  }
  .data {
    width: 190px;
    vertical-align: top;
  }
  .table-cont {
    padding-top: 40px;
    margin: 40px 0 60px;
  }
  .page-div {
    width: 100%;
    margin-top: 15px;
    position: fixed;
    background: #fff;
    width: calc(100% - 270px);
    height: 60px;
    z-index: 99;
    bottom: 0;
    padding-top: 15px;
    .page-div-left {
      float: left;
    }
    .page-div-page {
      float: right;
      margin-right: 15px;
    }
  }
  .title-btn {
    vertical-align: top;
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/questions/dajuan.vue